/** Shared report UI primitives */
import { useState, useRef } from 'react'
import { PortalDropdown } from '@/components/ui/portal-dropdown'

export function StatCard({ title, value, sub, color }: { title: string; value: string | number; sub?: string; color?: string }) {
  return (
    <div className="rep-stat-card">
      <p className="rep-stat-label">{title}</p>
      <p className="rep-stat-value" style={color ? { color } : undefined}>{value}</p>
      {sub && <p className="rep-stat-sub">{sub}</p>}
    </div>
  )
}

export function fmt$(v: number) {
  if (v == null || isNaN(v)) return '$0'
  if (v >= 1_000_000) return `$${(v / 1_000_000).toFixed(1)}M`
  if (v >= 1_000) return `$${(v / 1_000).toFixed(0)}K`
  return `$${v.toLocaleString()}`
}

export function fmtNum(v: number) {
  return v.toLocaleString()
}

export function ChartTooltip({ active, payload, label }: any) {
  if (!active || !payload?.length) return null
  return (
    <div className="rep-tooltip">
      {label && <p className="rep-tooltip-label">{label}</p>}
      {payload.map((entry: any, i: number) => (
        <div key={i} className="rep-tooltip-row">
          <span className="rep-tooltip-dot" style={{ backgroundColor: entry.color }} />
          <span className="rep-tooltip-name">{entry.name}:</span>
          <span className="rep-tooltip-value">{typeof entry.value === 'number' ? entry.value.toLocaleString() : entry.value}</span>
        </div>
      ))}
    </div>
  )
}

/** Info icon with hover tooltip — explains "why" for each chart type */
export function InfoTooltip({ text }: { text: string }) {
  const [show, setShow] = useState(false)
  const wrapRef = useRef<HTMLSpanElement>(null)

  return (
    <span className="rep-info-wrap" ref={wrapRef}
      onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      <svg className="rep-info-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" />
      </svg>
      {/* Portaled so the tip isn't clipped by .rep-content's overflow-y:auto (icon is pinned at the top of the scroll area). */}
      <PortalDropdown open={show} anchorRef={wrapRef} onClose={() => setShow(false)} placement="top-end" offset={10} className="rep-info-tip">
        {text}
      </PortalDropdown>
    </span>
  )
}
